import React from 'react';
import { Outlet } from 'react-router-dom';
import SubNav from './SubNav';
import { useAttention } from '../attention';

/**
 * The frame around a section: its tab strip, then the active tab's page.
 *
 * Badge counts come from the shared attention poll rather than a per-section
 * fetch, so a tab can say it needs attention without costing a request each
 * time you switch sections.
 */
export default function SectionLayout({ section }) {
  const { badges } = useAttention();
  return (
    <>
      <SubNav section={section} badges={badges} />
      <Outlet />
    </>
  );
}
